import BaseValidation from '@/forms/Validations/BaseValidation';
import NameValidation from '@/forms/FormElements/Rows/NameRow/NameRow.validation';
import EmailValidation from '@/forms/FormElements/Rows/EmailRow/EmailRow.validation';
import PhoneValidation from '@/forms/FormElements/Rows/PhoneRow/PhoneRow.validation';

import { names } from './ChartersRequestForm.types';
import { requiredIf } from 'vuelidate/lib/validators';
import { between } from 'vuelidate/lib/validators';

const numberOfGuestsValidation = new BaseValidation([
  {
    name: names.NumberOfGuests,
    rules: { required: requiredIf(function(){
      //@ts-ignore
      return this.TypeId === 1
    }),
      range: between(16, 148)
    },
    messages: {
      required: 'Enter the number of guests',
      range: 'Number of guests should be between 16 and 148',
    },
  },
]);

const expectedTravelDatesValidation = new BaseValidation([
  {
    name: names.ExpectedTravelDate,
    rules: {},
    messages: {},
  },
]);

const organizationValidation = new BaseValidation([
  {
    name: names.Organization,
    rules: {},
    messages: {},
  },
]);

const interestDestinationsValidation = new BaseValidation([
  {
    name: names.InterestDestinations,
    rules: { required: requiredIf(function(){
      //@ts-ignore
      return this.TypeId === 1
    }) },
    messages: {
      required: 'Enter the destinations are you interested in',
    },
  },
]);

const expectedTravelDateMonthValidation = new BaseValidation([
  {
    name: names.ExpectedTravelDateMonth,
    rules: { required: requiredIf(function(){
      //@ts-ignore
      return this.TypeId === 1
    }) },
    messages: {
      required: 'Select the expected travel date month',
    },
  },
]);

const expectedTravelDateYearValidation = new BaseValidation([
  {
    name: names.ExpectedTravelDateYear,
    rules: { required: requiredIf(function(){
      //@ts-ignore
      return this.TypeId === 1
    }) },
    messages: {
      required: 'Select the expected travel date year',
    },
  },
]);


const messageValidation = new BaseValidation([
  {
    name: names.Message,
    rules: { required: requiredIf(function(){
      //@ts-ignore
      return this.TypeId === 1
    }) },
    messages: {
      required: 'Enter your charter group, goals, and interests',
    },
  },
]);

export default () => {
  const validations = [
    NameValidation(names.Person),
    PhoneValidation(names.Phone, { isRequired: true } ),
    EmailValidation(names.Person),
    messageValidation,
    organizationValidation,
    numberOfGuestsValidation,
    expectedTravelDatesValidation,
    interestDestinationsValidation,
    expectedTravelDateMonthValidation,
    expectedTravelDateYearValidation,
  ];

  return {
    validations: BaseValidation.getRules(validations),
    messages: BaseValidation.getMessages(validations),
    model: BaseValidation.getModel(validations),
  };
};
